export default {
      id: "shipment__point-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#shipment__point",
      toString: function () {
        return this.url;
      }
    }